import Swiper from 'swiper';
import { Navigation, Pagination, Autoplay, Thumbs, EffectFade, Controller  } from 'swiper/modules';
import 'swiper/css';
Swiper.use([Navigation, Pagination, Autoplay, Thumbs, EffectFade, Controller ]);
import { state, profabCompareRemoveFromArray } from './shared-variables';

import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

(function ($) {
    let menuWidth = 1200;
    let subMenuClass = '.profab-main-menu .current-menu-item .sub-menu, .profab-main-menu .current-page-ancestor .sub-menu';
    let subSubMenuClass = '.profab-overlay-menu .menu > li.menu-item-has-children .profab-submenu ul > li.menu-item-has-children  > ul.sub-menu > li.menu-item-has-children > ';
    let homeSlider = null;
    let modelSliderThumb = null;
    let modelSlider = null;
    let publicationsSlider = null;
    let realisationsSlider = null;
    let initPublicationsSlider = false;
    let initRealisationsSlider = false;
    let galleryRealisationSliderThumb = null;
    let galleryRealisationSlider = null;
    let galleryRealisationModelSliderThumb = null;
    let galleryRealisationModelSlider = null;
    let realisationTestimoniesSlider = null;
    let player = $('#model_visit').length ? MetarealPlayerSDK.create("model_visit") : null;
    let playerSticky = $('#model_visit_sticky').length && $('#model_visit').length ? MetarealPlayerSDK.create("model_visit_sticky") : null;
    let elementEmpty = `<div class="profab-compared-empty"></div>`;
    let elementsToCompare = null;
    let baseFontSize = 16;
    let infoWindow = typeof google !== 'undefined' ? new google.maps.InfoWindow() : null;
    let mapOptions;
    let map;
    let marker;
    let coords = Array();
    let prevent = false;

    let arrLeonardGTMTrackingFormPath = [
      "/nous-joindre/",
      "/nous-joindre/merci/",
      "/en/join-us/",
      "/en/join-us/thank-you/",
      "/soumission/",
      "/soumission/merci/",
      "/en/quote/",
      "/en/quote/thank-you"
    ]

    let tId = setInterval(function () {
      if (document.readyState == "complete") onComplete()
  }, 11);

    $(document).ready(function () {
      profabRedirectContactForm();
      initLeonardGTMTracking();

      
      const show_region = false;

      show_region && $(document).on('click', '.region-switcher', profabAddCookieRegion);

      const searchParamsPro = new URLSearchParams(window.location.search);

      if(searchParamsPro.has('view_on') && !$('.leo-region').length){
        profabAjaxOntario('on');
      }

      if(show_region && !$('.leo-region').length){
        let region = getCookie('leoregion');

        if(region && region != 'qc'){
          profabAjaxOntario(region);
        }
        else if(!getCookie('leoregion')){
          $.ajax({
            beforeSend: function () {
            
            },
            url: ajax.url,
            type: "post",
            data: {
              action: "profab_get_geo_region",
            },
            success: function (data) {
              $(data).insertBefore("header");
            }
          });
        }
      }

      $(document).on('click', '#close_geo_region', profabCloseGeoRegion);
      $(document).on('click', '.profab-geo-region', profabClosePopupRegionOutside);
      $(document).on('click', '#profab_visit_ontario', profabVisitOntario);
      $(document).on('touchstart', '.profab-main-menu .menu > li.menu-item-has-children > a', profabTouchStart);

      $(document).on("click", ".profab-menu-open", profabOpenMenu);
      $(document).on("click", ".profab-overlay-menu .menu > li.menu-item-has-children > a", profabHeaderOpenSubMenu);
      $(document).on("click", ".profab-overlay-menu .menu > li.menu-item-has-children .profab-submenu ul > li.menu-item-has-children > a", profabHeaderOpenSubSubMenu);
      $(document).on("click", subSubMenuClass + "a, " + subSubMenuClass + 'span', profabHeaderOpenSubSubSubMenu);
      $(document).on("click", ".profab-footer-menu .menu > li.menu-item-has-children > a", profabFooterOpenSubMenu);
      $(window).on("resize", profabResize);
      $(document).on('click', '.profab-menu-mobile-open .menu-icon, .profab-overlay-menu .menu-icon.close-icon', profabToggleOverlayMenu);
      $(document).on('mouseenter', '.profab-home-slider-icon:not(.month), .profab-home-slider-icon.month a', profabToggleInSlide);
      $(document).on('mouseleave', '.profab-home-slider-icon:not(.month), .profab-home-slider-icon.month a', profabHomeResetSlide);
      $(document).on('click', '.profab-home-slider-icon:not(.month), .profab-home-slider-icon.month a', profabToggleInSlide);
      $(document).on('click', '.profab-matterport .profab-visit-play', profabMatterportClicked);
      $(document).on('click', '.profab-favorite-close', profabToggleFavorite)
      $(document).on('click', '.profab-row', profabFilterRow);
      $(document).on('click', '.profab-column', profabFilterColumn);
      $(document).on('click', '#profab-close-filters, .profab-open-filters', profabToggleFilters);
      $(document).on('change', 'input[name=profab_compare_models]', profabCompareModels);
      $(document).on('click', '.profab-compared-item', profabCompareRemoveModel);
      $(document).on('click', '#profab_search, #profab_search_mobile', profabToggleSearch);
      $(document).on('click', '.profab-overlay-search .menu-icon.close-icon', profabToggleSearch);
      $(document).on('click', '.filters-layout .profab-search-icon', profabToggleFilterSearch);
      $(document).on('click', '.post-attribute-block.toggle .filter-title', profabToggleFilterBox);
      $(document).on('click', '#profab_offical_plan', profabToggleFancyPlan);
      $(document).on('click', '#profab_configurator, .profab-configurator #profab_close_overlay, #profab_configurator_sticky, #model_configurator_sticky', profabToggleConfigurator);
      $(document).on('click', '#profab_visit_toggle, .profab-visit-overlay #profab_close_overlay, #profab_visit_overlay_sticky, #model_visit_sticky', profabToggleVisit);
      $(document).on('click', '.profab-overlay-container.profab-configurator', profabClosePopupOutside);
      $(document).on('click', '.profab-overlay-container.profab-visit-overlay', profabVisitClosePopupOutside);

      $('.profab-select select').change(profabSelect);

      if($('.profab-select').length){
        profabSelects();
      }

      let arFormFieldId = [143,253];
      arFormFieldId.forEach((item) => {
        if($("dl[data-name='item_meta["+item+"]']").length){
          $("dl[data-name='item_meta["+item+"]'] dd ul li:first-child").attr("data-value", "");
        }
      })


      if($('.arf_form #brand-div').length){
        $('.arf_form #brand-div').remove();
      }
      $(window).scroll(function () {
        debounce(profabHandleScroll, 25);
      });

      $(document).on("keyup", "#profab-searchpage-input", function () {
        let keyword = "";
        let lang = "/";
        if ($(this).val() != "") {
          keyword = lang + "?s=" + $(this).val();
        }
        $("#profab_search_form").attr("action", keyword);
      });

      $(".header-search .profab-search").keyup(delay(ajaxSearch, 500));
      $(".header-search .profab-search").on("search", ajaxClearSearch);

      if($('.profab-timeline-slider').length){
        profabTimelineSlider();
      }
      
      if($('.profab-home-swiper').length){
        profabHomeSwiper();
      }
      if($('.plans-swiper').length){
        profabPlansSwiper();
      }
      if($('.profab-model-swiper-thumb').length){
        profabModelSwiperThumb();
        Fancybox.bind('[data-fancybox="gallery"]', {});
        Fancybox.bind('[data-fancybox="plan-swiper"]', {});
      }
      if($('.profab-model-swiper').length){
        profabModelSwiper();
      }

      // Use event delegation for modal triggers to work with dynamically loaded content
      $(document).on('click', '.modal-trigger', function(e) {
        e.preventDefault();
        var modalId = $(this).data('modal-trigger');
        var $modal = $('#' + modalId);
        
        if ($modal.length) {
            // Show the modal
            $modal.removeClass('hidden');
            $('body').addClass('overflow-hidden');
            
            // Focus trap inside modal
            $modal.focus();
        }
      });

      // Close modal when clicking the close button (use event delegation)
      $(document).on('click', '.profab-modal-close', function() {
          var $modal = $(this).closest('.profab-modal');
          $modal.addClass('hidden');
          $('body').removeClass('overflow-hidden');
      });
      
      // Close modal when clicking outside the content (use event delegation)
      $(document).on('click', '.profab-modal', function(e) {
          if (e.target === this) {
              $(this).addClass('hidden');
              $('body').removeClass('overflow-hidden');
          }
      });
      
      // Close modal on Escape key press
      $(document).on('keydown', function(e) {
          if (e.key === 'Escape') {
              $('.profab-modal:not(.hidden)').addClass('hidden');
              $('body').removeClass('overflow-hidden');
          }
      });
      
      if(player){
        player.load(metareal.url, () => {
          player.setWelcomeScreen({
            play: false,
            welcome: false,
            loading:false,
          });

          /*$('.profab-metareal .profab-visit-play').click(function(){
            $('.profab-metareal .profab-visit-play-container, .profab-metareal .profab-visit-image-overlay').addClass('clicked');
            $('#model_visit').removeClass('profab-gradient-visit');
            player.startShowcase(true);
          });*/

          $('.profab-metareal .profab-visit-play-button, #profab_visit_toggle, #profab_visit_overlay_sticky, #profab_configurator_sticky').click(function(){
            if(!$('.profab-metareal .profab-visit-play-button').hasClass('clicked')){
              $('.profab-metareal .profab-visit-play-button').addClass('clicked');
              $('#model_visit').removeClass('profab-gradient-visit');
              player.startShowcase(true);
            }   
          });
  
        });

        player.setEventListener( "ready", profabVisitReady );
      }

      if(playerSticky){
        console.log('salut')
        playerSticky.load(metareal.url, () => {
          playerSticky.setWelcomeScreen({
            play: false,
            welcome: false,
            loading:false,
          });

         /* $('.profab-metareal .profab-visit-play').click(function(){
            $('.profab-metareal .profab-visit-play-container, .profab-metareal .profab-visit-image-overlay').addClass('clicked');
            $('#model_visit').removeClass('profab-gradient-visit');
            player.startShowcase(true);
          });

          $('.profab-metareal .profab-visit-play-button').click(function(){
            $('.profab-metareal .profab-visit-play-button').addClass('clicked');
            $('#model_visit').removeClass('profab-gradient-visit');
            player.startShowcase(true);
          });
  */
        });

        playerSticky.setEventListener( "ready", profabVisitReady );
      }

      $(document).on('click', '.profab-matterport .profab-visit-play-button', profabMatterportClicked);

      if($('.profab-publications-swiper').length){
        if($(window).width() <= 768) {
          profabPublicationsSwiper();
        }
        window.addEventListener("resize", profabPublicationsSwiper);
      }
      if($('.profab-realisations-swiper').length){
        if($(window).width() <= 768) {
          profabRealisationsSwiper();
        }
        window.addEventListener("resize", profabRealisationsSwiper);
      }

      if($('.profab-realisation-gallery .profab-gallery').length){
        profabGallerySwiper();
        Fancybox.bind("[data-fancybox]", {});
      }

      if($('.profab-flexible-gallery .profab-gallery').length){
        profabFlexibleGallerySwiper();
      }

      if($('.profab-realisation-model .profab-gallery').length){
        profabModelGallerySwiper();
      }

      if($('.profab-realisation-testimonies .profab-testimonies').length){
        profabTestimoniesSwiper();
      }

      if($('.flexible-video .wp-video').length) {
        $('.flexible-video .wp-video').on('click', profabPlayAndPause);
      }

      if($('.flexible-form #city_select').length) {
        $('.wpcf7-form-control.wpcf7-submit').on('click', function(e) {
          if($('.flexible-form #city_select').val() == null) {
            $('.flexible-form .form-error').removeClass('hidden');
            e.preventDefault();
          }
          else {
            if(!$('.flexible-form .form-error').hasClass('hidden')) {
              $('.flexible-form .form-error').addClass('hidden');
            }
          }
        });

        $('.flexible-form #city_select').on('change', function() {
          let cityName = this.value;

          $.ajax({
            beforeSend: function () {
              $('.wpcf7-hidden[name="city"]').val(cityName);
            },
            url: ajax.url,
            type: "post",
            data: {
              action: "profab_join_city_content",
              location: cityName,
            },
            success: function (data) {
              $(".profab-join").html(data);
              $(".flexible-form .form-address").html($(".join-content .join-address").html());
              if($(".join-content .join-map").data('latitude') && $(".join-content .join-map").data('longitude')){
                marker = null;
                let latitude = $(".join-content .join-map").data('latitude');
                let longitude = $(".join-content .join-map").data('longitude');
                latitude = latitude ? latitude.toString().replace('‑', '-') : latitude;
                longitude = longitude ? longitude.toString().replace('‑', '-') : longitude;
                coords = Array();
                coords[coords.length] = [$(".join-content .join-map").data('address'), latitude, longitude, 'profab']

                for (let i = 0; i < coords.length; i++) {
                  marker = new google.maps.Marker({
                      position: new google.maps.LatLng(coords[i][1], coords[i][2]),
                      icon: '/wp-content/themes/pro-fab-website/images/icon/marker-'+coords[i][3]+'.png'
                  });
        
                  google.maps.event.addListener(marker, 'click', (function (marker, i) {
                      return function () {
                          infoWindow.setContent(coords[i][0]);
                          infoWindow.open(map, marker);
                      }
                  })(marker, i));
                  
                }
                let centerCoords = new google.maps.LatLng(latitude, longitude);
                mapOptions.zoom = 12;
                mapOptions.center = centerCoords;
                map = new google.maps.Map(
                  document.getElementById("gMap"), mapOptions
                );
                marker.setMap(map);

              }
              else if($(".join-content .join-map img").length){
                $(".flexible-form .form-map").html($(".join-content .join-map").html());
              }
              
              profabFlexibleGallerySwiper();
            },
          });
        });
      }

      if($('.flexible-faq .flexible-faq-container details').length) {
        $('.flexible-faq .flexible-faq-container summary').on('click', function(e){
          e.preventDefault();
        });
        $('.flexible-faq .flexible-faq-container details').on('click', function(){
          if(this.open) {
            this.open = false;
          }
          else {
            this.open = true;
          }
        });

        profabResizeDetails();
        window.addEventListener("resize", profabResizeDetails);
      }
      if($('.page-template-template-inspiration').length){
        $('.exterior-design-block-content').addClass('hidden');
        $('.exterior-design-block-title').addClass('hidden');
        toggleExteriorBlock();
        $('input[data-is-exterior="1"]').on('change', toggleExteriorBlock);
      }
  });

  function profabTouchStart(e){
    if(window.innerWidth > menuWidth) {
      $('.profab-main-menu').addClass('prevent-tablet');
    }
  }

  function toggleExteriorBlock() {
		if ($('input[data-is-exterior="1"]').is(':checked')) {
      console.log('checked');
			$('#exterior-design-block').removeClass('hidden');
      $('.design-block-content').removeClass('hidden');
      $('.exterior-design-block-title').removeClass('hidden');
		} else {
      console.log('test');
			$('#exterior-design-block').addClass('hidden');
      $('.exterior-design-block-content').addClass('hidden');
      $('.exterior-design-block-title').addClass('hidden');
      $('#exterior-design-block input[type="checkbox"]').prop('checked', false);
		}
	}

  function profabHandleScroll() {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 50) {
      $(".profab-menu").removeClass("scrolled-top");
      $(".profab-menu").addClass("scrolled");
    } else {
      if (scrollTop > 50) {
        if ($(subMenuClass).length) {
          $(".profab-menu").addClass("scrolled-top");
        }
      }
    }
    if (scrollTop == 0) {
      $(".profab-menu").removeClass("scrolled");
      $(".profab-menu").removeClass("scrolled-top");
    }

    //$('footer, main').css('transform', 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, -'+scrollTop+', 0, 1)');
  }

  function ajaxSearch(e) {
    let perPage = 3;
    let paginate = 0;
    if (e.target.id == "profab-searchpage-input") {
      perPage = 12;
      paginate = 1;
    }
    if ($(this).val() == "") {
      ajaxClearSearch(e);
    } else {
      $.ajax({
        beforeSend: function () {
          $(".search-loading").removeClass("hidden");
        },
        url: ajax.url,
        type: "post",
        data: {
          action: "profab_search_results",
          keyword: $(this).val(),
          perPage: perPage,
          paginate: paginate,
          leoregion: getCookie('leoregion'),
        },
        success: function (data) {
          if (e.target.id == "profab-searchpage-input") {
            jQuery("#profab_searchpage_results").html(data);
          } else {
            jQuery(".search_results.profab-listing").html(data);
          }

          $(".search-loading").addClass("hidden");
        },
      });
    }
  }
  function profabToggleOverlayMenu(){
    $('.profab-overlay-menu').toggleClass('opened');
    $('body').toggleClass('opened');
    if($('.profab-menu').hasClass('search-opened')){
      $('.profab-menu').removeClass('search-opened')
    }
  }
  function ajaxClearSearch(e) {
    if (e.target.id == "profab-searchpage-input") {
      jQuery("#profab_searchpage_results").empty();
    } else {
      jQuery("#profab_search_results").empty();
    }
  }

  function debounce(method, delay) {
    clearTimeout(method._tId);
    method._tId = setTimeout(function () {
      method();
    }, delay);
  }

  function delay(callback, ms) {
    var timer = 0;
    return function () {
      var context = this,
        args = arguments;
      clearTimeout(timer);
      timer = setTimeout(function () {
        callback.apply(context, args);
      }, ms || 0);
    };
  }

  function profabOpenMenu() {
    $("header.profab-menu").toggleClass("profab-menu-opened");
    $(".profab-menu-open").toggleClass("profab-menu-close");
  }

  function profabHeaderOpenSubMenu(e) {
    e.preventDefault();
    profabOpenSubMenu(this, 'profab-submenu');
  }

  function profabFooterOpenSubMenu(e){
    let winWidth = window.innerWidth;
    if (winWidth < 1024) {
      e.preventDefault();
      profabOpenSubMenu(this, 'sub-menu');
    }
  }

  function profabHeaderOpenSubSubMenu(e) {
    e.preventDefault();
    profabOpenSubMenu(this, 'sub-menu');
  }

  function profabHeaderOpenSubSubSubMenu(e) {
    e.preventDefault();
    profabOpenSubMenu(this, 'profab-submenu-2');
  }

  function profabOpenSubMenu(el, subMenuClass) {
    let subMenuSelected = "";
    let isOpened = $(el).parent().hasClass('opened') ? true : false;
    let allSubMenu = $(el)
      .parent()
      .parent()
      .find("."+subMenuClass)
      .not($(el).parent().find("."+subMenuClass));

    subMenuSelected = $(el).parent().find("."+subMenuClass).first();
    
    let allMenuLi = $(el).closest('ul.menu').children('li').not($(el).parents('li'));

    $(el).parent().removeClass('opened');
    $(el).closest('ul.sub-menu').children('li').removeClass('opened');
    allMenuLi.removeClass('opened');

    if(!isOpened){
      $(el).parent().addClass('opened');
    }

    allSubMenu.removeClass(subMenuClass+"-opened");
    subMenuSelected.toggleClass(subMenuClass+"-opened");
  }


  function profabResize(e) {
    let winWidth = window.innerWidth;
    if (winWidth > menuWidth) {
      $(".profab-main-menu .sub-menu").removeClass("sub-menu-opened");
      $(".profab-main-menu .menu > li > a").removeClass(
        "profab-sub-menu-selected"
      );
      $(".profab-menu-open").removeClass("profab-menu-close");
      $("header.profab-menu").removeClass("profab-menu-opened");
    } else {
      $(".profab-main-menu .sub-menu").removeAttr("style");
    }
  }

  function profabHomeSwiper(){
    homeSlider  = new Swiper('.profab-home-swiper', {
      speed: 600,
      loop: true,
      effect: 'fade',
      grabCursor: true,
    });

    homeSlider.on('slideChange', function () {
      let sliderIndex = homeSlider.realIndex - 1;
      $('.profab-home-slider-icon').removeClass('active');
      if(sliderIndex >= 0){
        $('.profab-home-slider-icon').eq(sliderIndex).addClass('active');
      }
    });
  }

  function profabPlansSwiper(){
    homeSlider  = new Swiper('.plans-swiper', {
      speed: 600,
      loop: false,
      effect: 'fade',
      grabCursor: true,
      pagination: {
        el: '.plans-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.plans-navigation .profab-swiper-next',
        prevEl: '.plans-navigation .profab-swiper-prev',
      },
    });
  }

  function profabModelSwiperThumb(){
    modelSliderThumb = new Swiper('.profab-model-swiper-thumb', {
      grabCursor: true,
      slidesPerView: 1,
      spaceBetween: 18,
      loop: true,
      navigation: {
        nextEl: '.profab-swiper-next',
        prevEl: '.profab-swiper-prev',
      },
      breakpoints: {
        480: {
          slidesPerView: 2,
        },
        1280: {
          slidesPerView: 3,
        }
      }
    });
  }

  function profabModelSwiper(){
    modelSlider  = new Swiper('.profab-model-swiper', {
      grabCursor: true,
      slidesPerView: 1,
      loop: true,
      thumbs: {
        swiper: modelSliderThumb,
      },
      effect: 'fade',
    });
    
    modelSliderThumb.on('slideChangeTransitionStart', function() {
      let index_currentSlide = modelSliderThumb.realIndex;
      modelSlider.slideToLoop(index_currentSlide, 500, false);
    });
  }

  function profabPublicationsSwiper(){   
    if($(window).width() <= 768) {
      if(!initPublicationsSlider) {
        initPublicationsSlider = true;
        publicationsSlider = new Swiper('.profab-publications-swiper', {
          spaceBetween: 30,
          speed: 500,
          loop: true,
          grabCursor: true,
          slidesPerView: 1,
          centeredSlides: true,
          pagination: {
            clickable: true,
            el: ".swiper-pagination",
          },
          breakpoints: {
            768: {
              centeredSlides: false,
              slidesPerView: 3,
            }
          }
        });
      }
    }
    else {
      if(initPublicationsSlider) {
        initPublicationsSlider = false;
        publicationsSlider.destroy(true, true);
      }
    }
  }
  function profabRealisationsSwiper(){   
    if($(window).width() <= 768) {
      if(!initRealisationsSlider) {
        initRealisationsSlider = true;
        realisationsSlider = new Swiper('.profab-realisations-swiper', {
          speed: 500,
          loop: true,
          grabCursor: true,
          slidesPerView: 1,
          centeredSlides: true,
          spaceBetween: 18,
          pagination: {
            clickable: true,
            el: ".swiper-pagination",
          },
        });
      }
    }
    else {
      if(initRealisationsSlider) {
        initRealisationsSlider = false;
        realisationsSlider.destroy(true, true);
      }
    }
  }
  function profabGallerySwiper(){
    galleryRealisationSliderThumb = new Swiper('.profab-realisation-gallery .profab-gallery-thumb', {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
      autoHeight: true,
      breakpoints: {
        767: {
          direction: "vertical",
        }
      }
    });

    galleryRealisationSlider = new Swiper('.profab-realisation-gallery .profab-gallery', {
      spaceBetween: 10,
      loop: true,
      thumbs: {
        swiper: galleryRealisationSliderThumb,
      },
      navigation: {
        nextEl: ".profab-realisation-gallery .swiper-navigation .swiper-button-next",
        prevEl: ".profab-realisation-gallery .swiper-navigation .swiper-button-prev",
      },
    });
  }

  function profabModelGallerySwiper(){
    galleryRealisationModelSliderThumb = new Swiper('.profab-realisation-model .profab-gallery-thumb', {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
      autoHeight: true,
      breakpoints: {
        767: {
          direction: "vertical",
        }
      }
    });

    galleryRealisationModelSlider = new Swiper('.profab-realisation-model .profab-gallery', {
      spaceBetween: 10,
      loop: true,
      thumbs: {
        swiper: galleryRealisationModelSliderThumb,
      },
    });
  }

  function profabFlexibleGallerySwiper(){
    let galleryFlexibleRealisationsSlider;
    let galleryFlexibleRealisationsSliderThumb;

    $('.profab-flexible-gallery .profab-gallery-thumb').each(function() {
      let galleryParent = $(this).parents('.profab-flexible-gallery');

      galleryFlexibleRealisationsSliderThumb = new Swiper('#' + galleryParent.attr('id') + ' .profab-gallery-thumb', {
        spaceBetween: 10,
        slidesPerView: galleryParent.data('thumbs'),
        freeMode: true,
        watchSlidesProgress: true,
        autoHeight: true,
        breakpoints: {
          767: {
            direction: "vertical",
          }
        }
      });

      galleryFlexibleRealisationsSlider = new Swiper('#' + galleryParent.attr('id') + ' .profab-gallery', {
        spaceBetween: 10,
        loop: true,
        thumbs: {
          swiper: galleryFlexibleRealisationsSliderThumb,
        },
        navigation: {
          nextEl: ".profab-flexible-gallery#" + galleryParent.attr('id') + " .swiper-navigation .swiper-button-next",
          prevEl: ".profab-flexible-gallery#" + galleryParent.attr('id') + " .swiper-navigation .swiper-button-prev"
        },
      });
    });
  }

  function profabTestimoniesSwiper(){
    realisationTestimoniesSlider = new Swiper('.profab-realisation-testimonies .profab-testimonies', {
      spaceBetween: 10,
      loop: true,
      autoHeight: true,
      navigation: {
        nextEl: ".profab-realisation-testimonies .swiper-navigation .swiper-button-next",
        prevEl: ".profab-realisation-testimonies .swiper-navigation .swiper-button-prev",
      },
    });
  }

  function profabToggleInSlide(e){
    let winWidth = window.innerWidth;
    if (winWidth >= 1024) {
      let element = $(this).hasClass('.profab-home-slider-icon') ? $(this) : $(this).closest('.profab-home-slider-icon');
      homeSlider.slideToLoop(element.index() + 1, 600);
      profabHomeHidden('hover');
    }
  }

  function profabHomeResetSlide(){
    homeSlider.slideToLoop(0);
    profabHomeHidden('reset');
  }

  function profabHomeHidden(state){
    if(state == 'reset') {
      if($('.profab-home-title').hasClass('hidden')) {
        $('.profab-home-title').removeClass('hidden');
      }
  
      if($('.profab-arch-transparent').hasClass('!hidden')) {
        $('.profab-arch-transparent').removeClass('!hidden');
      }
    }
    else {
      if(state == 'hover') {
        if(!$('.profab-home-title').hasClass('hidden')) {
          $('.profab-home-title').addClass('hidden');
        }
    
        if(!$('.profab-arch-transparent').hasClass('!hidden')) {
          $('.profab-arch-transparent').addClass('!hidden');
        }
      }
    }
  }

  function profabVisitReady(){
    $('.profab-metareal .profab-visit-play-container, .profab-metareal .profab-visit-image-overlay, .profab-metareal .profab-visit-play-button').addClass('started');
  }

  function profabMatterportClicked(){
    let winWidth = window.innerWidth;

    $('.profab-matterport .wpm-overlay').click();

    if (winWidth <= 600) {
      window.location.href = $('.profab-matterport .wpm-overlay').attr('href');
    }
  }

  function profabToggleFavorite(){
    $('.profab-favorite').toggleClass('opened');
  }

  function profabToggleSearch(){
    if($('.profab-overlay-menu').hasClass('opened')){
      profabToggleOverlayMenu();
    }
    $('body').toggleClass('opened');
    $('.profab-menu').toggleClass('search-opened');

    if($('.profab-menu').hasClass('search-opened')) {
      $('input.profab-search').focus();
    }
  }
  
  function profabToggleFilterSearch(){
    $('.filters-layout .profab-search').toggleClass('opened');
  }

  function profabFilterColumn(){
    $('#filtered-content').removeClass('row');
    $('#filtered-content').addClass('column');
  }

  function profabFilterRow(){
    $('#filtered-content').removeClass('column');
    $('#filtered-content').addClass('row');
  }

  function profabToggleFilters(){
    $('.profab-filters-panel .profab-panel').toggleClass('profab-panel-left');
    $('.profab-filters-panel').toggleClass('closed');
    $('.profab-filters-panel .profab-panel').removeClass('no-animation');
  }

  function profabPlayAndPause() {
    let controlButton = $(this).find('.mejs-playpause-button');
    let videoParent = $(this).parent().attr('id');

    if(!$(controlButton).hasClass('.mejs-play')) {
      $('#' + videoParent + ' .profab-visit-play-container').addClass('!opacity-0');
    }
  }

  function profabCompareModels(){
    if(!$(this).is(':checked')){
      profabCompareRemoveFromArray($(this).val());
    }
    let maximumItem = 4;
    if(state.modelsIds.length <= maximumItem-1){
      $("input:checkbox[name=profab_compare_models]:checked").each(function() {
        let id = $(this).val();
        let idExists = state.modelsIds.some(function(item) {
          return item.id === id;
        });
        
        if(!idExists){
          state.modelsIds.push({
            'id': $(this).val(),
            'src': $(this).parents('.profab-model-hover').children('img:first-child').attr('src'),
            'title': $(this).data('title'),
          });
        }
      });

      elementsToCompare = $.map(state.modelsIds, function(item) {
        return `<div class="profab-compared-item" data-id="${item.id}"><img src="${item.src}" alt="${item.title}"><span>${item.title}</span></div>`;
      });

      if(state.modelsIds.length < 4){
        maximumItem = maximumItem - state.modelsIds.length;
        for(let i = 0; i < maximumItem; i++){
          elementsToCompare = elementsToCompare.concat(elementEmpty);
        }
      }
      $('#profab_compared_models').html(elementsToCompare);
    }
    else{
      this.checked = !this.checked
      e.stopPropagation();
    }
    profabToggleCompare();
    profabChangeComparisonLink();
  }

  function profabCompareRemoveModel(){
    let idToRemove = $(this).data('id');

    profabCompareRemoveFromArray(idToRemove);

    if($('#profab_compare_'+idToRemove).length){
      $('#profab_compare_'+idToRemove).trigger('click');
    }
    else{
      $(this).remove();
      $('#profab_compared_models').append(elementEmpty);
    }

    profabToggleCompare();
    profabChangeComparisonLink();
  }
  function profabToggleCompare(){
    if(state.modelsIds.length > 0){
      $('.profab-comparaison').addClass('opened');
    }
    else{
      $('.profab-comparaison').removeClass('opened');
    }
  }

  function profabChangeComparisonLink(modelType){
    let modelsArr = state.modelsIds;
    modelsArr = modelsArr.map(function(item){
      return item.id
    })
    let queryString = `?type=${$('.profab-comparaison-link').data('type')}&model=${encodeURIComponent(modelsArr.join(','))}`
    $('.profab-comparaison-link').attr('href', $('.profab-comparaison-link').data('url') + queryString);
  }

  function profabSelects(){
    $('.profab-select').each(function(){
      let selectedText = $(this).find('option:checked').text();
      let width = 60 + (selectedText.trim().length * 8);
      $(this).find('select').css('width', pxToRem(width) + "rem");
    });
  }

  function profabSelect(){
    let selectedText = $(this).find('option:checked').text();
    let width = 60 + (selectedText.trim().length * 8);
    $(this).css('width', pxToRem(width) + "rem");
  }

  function pxToRem(pxValue) {

    // Calculate the value in rems
    const remValue = pxValue / baseFontSize;

    return remValue;
  }

  function profabToggleFilterBox(){
    $(this).parent().toggleClass('closed');
  }

  function profabRedirectContactForm() {
    document.addEventListener('wpcf7mailsent', function (event) {
        let redirectUrl = $('input[name=redirect_url]').val();
        if (redirectUrl != undefined) {
          location = redirectUrl;
        }
    }, false);
  }

  function onComplete() {
    clearInterval(tId);
    if($('#gMap').length && profab_map && profab_map.map_latitude){
      let latitude = profab_map && profab_map.map_latitude ? profab_map.map_latitude : null;
      let longitude = profab_map && profab_map.map_longitude ? profab_map.map_longitude : null;
      let address = profab_map && profab_map.map_address ? profab_map.map_address : null;
      let zoom = profab_map && profab_map.map_zoom ? profab_map.map_zoom : 12;
      zoom = parseFloat(zoom.replace(",", "."));
      latitude = parseFloat(latitude.replace('‑', '-'));
      longitude = parseFloat(longitude.replace('‑', '-'));
      let centerCoords = new google.maps.LatLng(latitude, longitude);

      let styles=[{featureType:"all",elementType:"all",stylers:[{saturation:"1"}]},{featureType:"administrative.country",elementType:"labels.text.fill",stylers:[{color:"#01406c"}]},{featureType:"administrative.province",elementType:"geometry",stylers:[{visibility:"on"}]},{featureType:"administrative.province",elementType:"labels.text",stylers:[{color:"#01406c"}]},{featureType:"administrative.province",elementType:"labels.text.fill",stylers:[{color:"#01406c"},{visibility:"simplified"}]},{featureType:"administrative.locality",elementType:"geometry",stylers:[{visibility:"off"}]},{featureType:"administrative.locality",elementType:"labels.text",stylers:[{color:"#01406c"},{visibility:"simplified"}]},{featureType:"administrative.neighborhood",elementType:"all",stylers:[{visibility:"on"},{saturation:"1"}]},{featureType:"administrative.neighborhood",elementType:"labels.text",stylers:[{color:"#4b4b4b"},{lightness:"1"},{saturation:"1"}]},{featureType:"administrative.neighborhood",elementType:"labels.text.fill",stylers:[{color:"#01406c"},{visibility:"simplified"}]},{featureType:"administrative.land_parcel",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"administrative.land_parcel",elementType:"geometry",stylers:[{visibility:"off"}]},{featureType:"landscape",elementType:"all",stylers:[{saturation:"-100"},{visibility:"off"}]},{featureType:"landscape",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"landscape.man_made",elementType:"all",stylers:[{visibility:"off"}]},{featureType:"landscape.natural",elementType:"all",stylers:[{visibility:"on"}]},{featureType:"landscape.natural",elementType:"geometry",stylers:[{visibility:"off"}]},{featureType:"landscape.natural.landcover",elementType:"all",stylers:[{visibility:"on"}]},{featureType:"landscape.natural.terrain",elementType:"all",stylers:[{visibility:"on"}]},{featureType:"poi",elementType:"all",stylers:[{saturation:"-100"},{visibility:"off"}]},{featureType:"poi",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"road",elementType:"all",stylers:[{saturation:"-100"}]},{featureType:"road",elementType:"geometry",stylers:[{lightness:57}]},{featureType:"road",elementType:"geometry.fill",stylers:[{lightness:"11"}]},{featureType:"road",elementType:"labels.text.fill",stylers:[{visibility:"on"},{lightness:24}]},{featureType:"road",elementType:"labels.icon",stylers:[{visibility:"off"}]},{featureType:"transit",elementType:"all",stylers:[{visibility:"on"},{saturation:"-100"}]},{featureType:"transit",elementType:"labels",stylers:[{visibility:"off"}]},{featureType:"water",elementType:"geometry.fill",stylers:[{saturation:"-100"},{lightness:"94"},{visibility:"on"}]},{featureType:"water",elementType:"labels",stylers:[{visibility:"off"}]}];
      let buttonStyle = "display:flex; color:white; width:fit-content; background-color:#333E48; padding:5px 15px; margin-top:15px; margin-left:auto; margin-right:auto;";

      mapOptions = {
          zoom: zoom,
          center: centerCoords,
          mapTypeControl: true,
          mapTypeId: google.maps.MapTypeId.ROADMAP,
          scrollwheel: false,
          draggable: true,
          styles: styles
      }


      //create the map, and place it in the HTML map div
      map = new google.maps.Map(
          document.getElementById("gMap"), mapOptions
      );

      coords[coords.length] = [address, latitude, longitude, 'profab'];

      if(profab_map && profab_map.map_markers){
        profab_map.map_markers.forEach(function(item){
          let marker_img = item.map_is_guildcrest ? 'guildcrest' : 'profab';
          let marker_latitude = item.map_markers_latitude;
          let marker_longitude = item.map_markers_longitude;

          if(item.map_is_center){
            let centerCoordsLocation = new google.maps.LatLng(marker_latitude, marker_longitude);
            map.setCenter(centerCoordsLocation);
          }
          

          let location_link = item.map_link ? '<a style="'+buttonStyle+'" href="'+item.map_link+'">'+profab_map.see_point_sale+'</a>' : '';
         
          coords[coords.length] = [item.map_markers_address + location_link, marker_latitude, marker_longitude, marker_img]
        });
      }

      let i;

      google.maps.event.addListener(window, "resize", function () {
          var center = map.getCenter();
          google.maps.event.trigger(map, "resize");
          map.setCenter(center);
      });

      for (i = 0; i < coords.length; i++) {
          marker = new google.maps.Marker({
              position: new google.maps.LatLng(coords[i][1], coords[i][2]),
              map: map,
              icon: '/wp-content/themes/pro-fab-website/images/icon/marker-'+coords[i][3]+'.png'
          });

          google.maps.event.addListener(marker, 'click', (function (marker, i) {
              return function () {
                  infoWindow.setContent(coords[i][0]);
                  infoWindow.open(map, marker);
              }
          })(marker, i));
      }
    }
  };
  function profabToggleFancyPlan(){
    Fancybox.fromSelector('[data-fancybox="plan"]');
  }
  function profabTimelineSlider(){
    let swiperTimelineSlider = new Swiper('.profab-timeline-slider', {
			slidesPerView: 1,
      breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1536: {
            slidesPerView: 3,
          },
      },
      navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
      },
		});
  }
  function profabToggleConfigurator(){
    $('.profab-overlay-container.profab-configurator').toggleClass('opened');
    $('body').toggleClass('opened');
  }
  function profabToggleVisit(){
    if($('.profab-matterport').length){
      $('.profab-visit-play-button').click();
    }
    else{
      $('.profab-overlay-container.profab-visit-overlay').toggleClass('opened');
      $('body').toggleClass('opened');
    }
  }
  
  function profabClosePopupOutside(e){
    if(e.target != this) return;
    profabToggleConfigurator();
  }
  function profabVisitClosePopupOutside(e){
    if(e.target != this) return;
    profabToggleVisit();
  }
  function initLeonardGTMTracking() {
    // Track CTA pointing to a «Leads Form»
    // -------
    let arrLeonardGTMTrackingCTA = [];

    for(let i=0; i<arrLeonardGTMTrackingFormPath.length; i++){
      arrLeonardGTMTrackingCTA.push("a.p-btn[href*='" + arrLeonardGTMTrackingFormPath[i] + "'], a.p-button[href*='" + arrLeonardGTMTrackingFormPath[i] + "']");
    }
  
    // Custom CSS rules here
    // arrLeonardGTMTrackingCTA.push(".custom-rule-for-CTA-pointing-to-leads-form a");
  
    $(arrLeonardGTMTrackingCTA.join(", ")).addClass("gtm-form-view");
  
    // Track «Leads form» submit button click
    // -------
    if(arrLeonardGTMTrackingFormPath.indexOf(window.location.pathname) != -1) {
      $("form button, form input[type=submit]").addClass("gtm-form-submited");
    }
  }

  function profabAjaxOntario(region = "on"){
    $('.profab-loading-region-container').addClass('loading');
    let url = window.location.href;
    let separator = url.includes('?') ? '&' : '?';
    $.get(`${url}${region != 'qc' ? `${separator}leoregion=${region}` : ''}`, function(html) {
      document.open();
      document.write(html);
      document.close();
      $('.profab-loading-region-container').removeClass('loading');
    });
  }

  function profabVisitOntario(){
    $('.profab-geo-region').removeClass('opened');
    document.cookie = `leoregion=on; path=/; max-age=5184000`;
    profabAjaxOntario('on');
  }

  function profabCloseGeoRegion(){
    $('.profab-geo-region').removeClass('opened');
  }
  function profabClosePopupRegionOutside(e){
    if(e.target != this) return;
    profabCloseGeoRegion();
  }
  function profabAddCookieRegion(e) {
    e.preventDefault();

    const region = this.getAttribute('data-region');
    document.cookie = `leoregion=${region}; path=/; max-age=5184000`;
    profabAjaxOntario(region);
  }
  function getCookie(name) {
    let match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }
  function profabResizeDetails() {
    //Get details element width, and apply a max-width on table-container
    let detailsWidth = $('.flexible-faq .flexible-faq-container details').width();
    $('.flexible-faq .flexible-faq-container details').find('.table-container').css('max-width', detailsWidth);
  }
})(jQuery);